<template>
  <div class="rating-stars-wrapper">
    <div v-for="(star, index) in stars" :key="index" class="rating-star">
      <svg viewBox="0 0 24 24" fill="none">
        <!-- Star border -->
        <path
          v-if="showStarBorder(star)"
          d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
          :stroke="color"
          stroke-width="2"
          fill="none"
        />

        <!-- Clip path for partial fills -->
        <defs v-if="star.fillPercentage > 0">
          <clipPath :id="star.clipId">
            <rect x="0" y="0" :width="star.fillPercentage + '%'" height="100%" />
          </clipPath>
        </defs>

        <!-- Filled portion -->
        <path
          v-if="star.fillPercentage > 0"
          d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
          :fill="color"
          :clip-path="'url(#' + star.clipId + ')'"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rating: {
      type: Number,
      required: true,
    },
    showOnlyFullStars: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '#DC2626',
    },
  },
  computed: {
    stars() {
      return Array.from({ length: 5 }, (_, i) => {
        const position = i + 1;
        const fillPercentage = this.calculateStarFillPercentage(position);
        return {
          position,
          fillPercentage,
          isFull: fillPercentage === 100,
          isHalf: fillPercentage > 0 && fillPercentage < 100,
          isEmpty: fillPercentage === 0,
          clipId: `star-fill-${position}-${Date.now()}-${i}`,
        };
      });
    },
  },
  methods: {
    calculateStarFillPercentage(position) {
      if (this.showOnlyFullStars) {
        return this.rating >= position ? 100 : 0;
      }

      if (this.rating >= position) {
        return 100;
      }

      const decimal = (this.rating - position) + 1;
      if (decimal > 0.7) {
        return 100;
      }
      if (decimal > 0.3) {
        return 50;
      }

      return 0;
    },
    showStarBorder(star) {
      if (this.showOnlyFullStars) {
        return star.isFull;
      }
      return true;
    },
  },
};
</script>

<style scoped>
.rating-stars-wrapper {
  display: flex;
  align-items: center;
  gap: 4px;
}

.rating-star {
  width: 16px;
  height: 16px;
}
</style>
